export const EMAIL_ADDRESS = 'emailAddress';
export const PATH_NAME = 'pathName';

export const REQUEST_HEADER = {
  [EMAIL_ADDRESS]: '',
  [PATH_NAME]: ''
};


// WEBPACK FOOTER //
// src/helpers/httpRequestHeader.js